<template>
  <Remixicon :class="{ met: isMet }" :name="isMet ? 'ri-checkbox-circle-line' : 'ri-close-circle-line'" />
</template>

<script>
  import { defineComponent } from 'vue';
  import Remixicon from '@/modules/icons/components/Remixicon';

  export default defineComponent({
    name: 'PasswordRequirementIcon',
    components: {
      Remixicon
    },
    props: {
      isMet: {
        type: Boolean
      }
    }
  });
</script>

<style lang="scss" scoped>
  @use '@/styles/modules/palette';

  svg {
    width: 16px;
    height: 16px;
    margin-left: 2px;
    margin-top: -4px;
    vertical-align: middle;
    color: palette.$status-error-color;

    &.met {
      color: palette.$status-success-color;
    }
  }
</style>
